import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import { useDtpDetailModel } from "./dtpDetailModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Button, Input, message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { ValidateErrorEntity } from "rc-field-form/es/interface";
import { useDictModel } from "@/views/base/dict/dictModel";
import { globalPrompt } from "@/components/message";
import { useExtractModel } from "./extract/extractModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";

export const TopButs: FC<RouterParamType> = ({ id, mode, formRef }) => {
    const { editFormVal,
        insertOrUpdateDtp,
        getDtpDetailOne,
        resetPageCache,
        transportGenerate,
        transportSave,
        transportManger,
        transportExamineManger
    } = useDtpDetailModel(({ addFormVal, editFormVal }) => [addFormVal, editFormVal]);
    const { fileList } = useExtractModel()
    const isEdit = mode === "edit";
    const { selectedNavId, replaceNav, findNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        if (!editFormVal.id && mode === "edit") {
            getDtpDetailOne(id)
        }
        if (mode === "add") {
            resetPageCache("add")
        }
    }, [mode]);

    //关闭页签的时候清除对应缓存
    useEffect(() => {
        return () => {
            !findNav("9-1-1") && resetPageCache("add")
            !findNav("9-1-2") && resetPageCache("edit");
        }
    }, [selectedNavId])

    const orderStatu: IDescription[] = [
        {
            label: "运输单据",
            value: editFormVal.code ?? "无",
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: "状态",
            value: getTreeNodeName(editFormVal.status ?? ""),
            color: DescriptionColorEnum.green,
            status: true
        },
        // {
        //     label: "状态",
        //     value: getTreeNodeName(editFormVal.status ?? ""),
        //     color: DescriptionColorEnum.green,
        //     status: true
        // },
    ]


    //表单提交
    const onSubmit = () => {
        //debugger
        formRef.current?.validateFields().then((val: any) => {
            let data = {
                ...val,
                dischargeName:getTreeNodeName(val.discharge),
                shipmentName:getTreeNodeName(val.shipment)
            }
            insertOrUpdateDtp(mode, data).then(res => {
                if (mode === "add" && res) {
                    resetPageCache("edit");
                    replaceNav("9-1-1", "9-1-2", { id: res as string, mode: "edit" });
                }
            })
        }).catch((err: ValidateErrorEntity<any>) => {
            message.warning(getFormValidatorErrText(err));
        })
    };
    const generate = async () => {
        let retData = await transportGenerate(editFormVal.code);
        retData && getDtpDetailOne(editFormVal.code)
    }
    const toExamine = async () => {

        let retData = await transportSave(editFormVal.code);
        retData && getDtpDetailOne(editFormVal.code)
    }
    const directorManager = () => {
        // debugger;
        // let billCodeArr =  fileList.filter(item => item.billCode === "")
        // if(billCodeArr.length!==0){
        //     message.warning("请补齐提单管理的所有提单编号，在进行总经理审核");
        //     return false;
        // }

        let advise: string = ""
        globalPrompt("modal", {
            title: "经理审核",
            type: "warning",
            text: <><span>经理是否同意审核</span>,
                <Input onChange={(e) => { advise = e.target.value }} /></>,
            okText: "同意",
            onOk: async () => {
                let retData = await transportManger({
                    advise,
                    code: editFormVal.code,
                    status: 0,
                })
                if (retData) { message.success("经理审核通过!"); getDtpDetailOne(editFormVal.code) };
            },
            cancelText: "驳回",
            onCancel: async () => {
                let retData = await transportManger({
                    advise,
                    code: editFormVal.code,
                    status: 1,
                })
                if (retData) { message.success("经理审核驳回!"); getDtpDetailOne(editFormVal.code) };
            }
        })
    }
    const directorReview = () => {
        let advise: string = ""
        globalPrompt("modal", {
            title: "总监审核",
            type: "warning",
            text: <><span>总监是否同意审核</span>,
                <Input onChange={(e) => { advise = e.target.value }} /></>,
            okText: "同意",
            onOk: async () => {
                let retData = await transportExamineManger({
                    advise,
                    code: editFormVal.code,
                    status: 0,
                })
                if (retData) { message.success("总监审核通过!"); getDtpDetailOne(editFormVal.code) };
            },
            cancelText: "驳回",
            onCancel: async () => {
                let retData = await transportExamineManger({
                    advise,
                    code: editFormVal.code,
                    status: 1,
                })
                if (retData) { message.success("总监审核驳回!"); getDtpDetailOne(editFormVal.code) };
            }
        })
    }

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.SHI_B_ED_OUT}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                hidden={!isEdit}
                disabled={!(editFormVal.status === "transport-status.init" || editFormVal.status === "transport-status.dir-reject")}
                onClick={() => generate()}
            >单据生成</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.SHI_B_ED_SUB}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                hidden={!isEdit}
                disabled={!(editFormVal.status === "transport-status.generate" || editFormVal.status === "transport-status.manger-reject")}
                onClick={() => toExamine()}
            >提交审核</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.SHI_B_ED_TUBE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                hidden={!isEdit}
                disabled={!(editFormVal.status === "transport-status.to-Manager-audit")}
                onClick={() => directorManager()}
            >经理审核</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.SHI_B_ED_LEAD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                hidden={!isEdit}
                disabled={!(editFormVal.status === "transport-status.to-dir-audit")}
                onClick={() => directorReview()}
            >总监审核</Button>
        </YhAuth>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={!isEdit}
            onClick={() => { }}
        >单据导出</Button> */}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => replaceNav(selectedNavId, "9-1")}
        >返回</Button>
        <YhAuth resCode={ResourceAuthEnum.SHI_B_ED_SAVE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    {
                        if (editFormVal.status === "transport-status.effect") {
                            message.warning("已生效的单据不可再次修改");
                            return;
                        }
                        onSubmit()
                    }
                }}
            >保存</Button>
        </YhAuth>
    </>

    return (
        <YhBox
            title={mode === "edit" ? orderStatu.map((item, index) => <Description key={index} {...item} />) : undefined}
            style={{ paddingBottom: 0, marginBottom: "10px" }}
            action={action}
        />
    )
}